var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(`height: ${_vm.height}px`)},[_c('div',{ref:"fixedBottom",staticClass:"fixed-bottom",class:{
    'fixed': _vm.isFixedScrollBar,
    'default-width': !_vm.isFixedScrollBar
  }},[_c('div',{ref:"fixedScrollBar",staticClass:"fixed-scroll-bar",class:{hide: !_vm.isScrollX || !_vm.isFixedScrollBar},on:{"mousedown":_vm.mouseEvent,"mouseup":_vm.mouseEvent,"scroll":_vm.scrollSlideBar}},[_c('div',{ref:"slideBar",staticClass:"slide-bar"})]),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }